import { ActionType } from 'typesafe-actions';

import SearchPage from '@interfaces/search-page';

import * as types from './types';
import * as actions from './actions';

export type SearchAction = ActionType<typeof actions>;

export interface SearchState {
    readonly searchValue?: string;
    readonly list: SearchPage;
    readonly isLoading: boolean;
    readonly error?: string | boolean;
}

const initialState: SearchState = {
    searchValue: '',
    list: { rows: [], meta: {} },
    isLoading: false,
    error: undefined
};

/* tslint:disable-next-line */
function reducer(state: SearchState = initialState, action: SearchAction): SearchState {
    switch (action.type) {
        case types.FETCH_SEARCH:
            return fetchSearch(state, action);

        case types.FETCH_SEARCH_SUCCESS:
            return fetchSearchSuccess(state, action);

        case types.FETCH_SEARCH_ERROR:
            return fetchSearchError(state, action);

        default:
            return state;
    }
}

function fetchSearch(state: SearchState, action: any) {
    const { page = 1, text } = action.payload;

    // Если загружается первая страница, обнуляем существующий список
    // что-бы показать content placeholders
    const list = {
        ...state.list,
        rows: page === 1 ? [] : state.list.rows
    };

    return {
        ...state,
        searchValue: text,
        list,
        isLoading: true,
        error: false
    };
}

function fetchSearchSuccess(state: SearchState, action: any) {
    const { meta, rows: actionRows } = action.payload;
    const rows = meta.pageNumber === 1
        ? actionRows
        : [...state.list.rows, ...actionRows];

    return {
        ...state,
        list: { meta, rows },
        isLoading: false,
        error: false
    };
}

function fetchSearchError(state: SearchState, action: any) {
    return {
        ...state,
        isLoading: false,
        error: action.payload
    };
}

export default reducer;
